package top.wcpe.allincore.ui.runtime.nbt

// JS：最小实现——结构自明成员真实现；语义复杂面（SNBT/路径/富文本解析）遇非空数据
// 显式 TODO 失败（ADR-0075 §5 宁显式失败不静默假实现）。mock 无 nbt 物品全链路可用。

actual interface NbtTag

actual class NbtCompound(private val entries: Map<String, NbtTag>) : NbtTag {

    actual fun resolve(path: String): NbtTag? {
        if (entries.isEmpty()) return null
        TODO("web 端未支撑非空 NBT 的路径解析（真源 SnbtCodec.resolve 语义），mock 场景请用无 nbt 物品")
    }

    actual fun isEmpty(): Boolean = entries.isEmpty()
}

actual class NbtList(internal val items: List<NbtTag>) : NbtTag

actual class NbtString(private val raw: String) : NbtTag {

    actual fun value(): String = raw
}

actual fun nbtToSnbt(tag: NbtTag): String = when (tag) {
    is NbtString -> "\"" + tag.value().replace("\\", "\\\\").replace("\"", "\\\"") + "\""
    is NbtCompound -> if (tag.isEmpty()) "{}" else TODO("web 端未支撑非空 COMPOUND 的 SNBT 序列化")
    is NbtList -> if (tag.items.isEmpty()) "[]" else TODO("web 端未支撑非空 LIST 的 SNBT 序列化")
    else -> TODO("web 端未支撑该 NBT 类型的 SNBT 序列化")
}

actual fun nbtListItems(list: NbtList): List<NbtTag> = list.items

actual val emptyNbtCompound: NbtCompound = NbtCompound(emptyMap())

actual fun nbtMapBridgeToMap(nbt: NbtCompound): Map<String, Any> {
    if (nbt.isEmpty()) return emptyMap()
    TODO("web 端未支撑非空 NBT 的 Map 桥接")
}

actual fun nbtViewsDisplayName(nbt: NbtCompound): String {
    if (nbt.isEmpty()) return ""
    TODO("web 端未支撑非空 NBT 的 display.Name 解析")
}

actual fun nbtViewsLore(nbt: NbtCompound): List<String> {
    if (nbt.isEmpty()) return emptyList()
    TODO("web 端未支撑非空 NBT 的 display.Lore 解析")
}

actual fun nbtViewsEnchanted(nbt: NbtCompound): Boolean {
    if (nbt.isEmpty()) return false
    TODO("web 端未支撑非空 NBT 的附魔标签解析")
}

actual fun nbtBinaryRead(bytes: ByteArray): NbtTag? = TODO("web 端未支撑二进制 NBT 解码（mock 数据层不产生 nbtBytes）")
